import theme from '@ifca-root/react-component/src/assets/theme'
import {
  Grid,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
} from '@material-ui/core'
import LocationOnIcon from '@material-ui/icons/LocationOn'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import WarningIcon from '@material-ui/icons/Warning'
import React from 'react'

interface CountDetailItem {
  asset_count_detail_id: string
  fa_asset_id: string
  asset_qty: number
  counted_qty: number
  cost_centre_id: string
  location_id: string
  count_note: string | null
  Asset?: {
    fa_asset_id: string
    asset_card_no: string
    name: string
    DocNo: string
  }
  CostCentre?: {
    CostCentreID: string
    Name: string
    Code: string
  }
  Location?: {
    fa_location_id: string
    name: string
  }
}

interface AssetsCountDetailitemContentProps {
  listItem: CountDetailItem[]
}

export const AssetsCountDetailitemContent = (
  props: AssetsCountDetailitemContentProps
) => {
  const { listItem = [] } = props
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  })

  if (!listItem || listItem.length === 0) {
    return (
      <div className="rm-padding table-wrap">
        <div style={{ padding: '20px', textAlign: 'center', color: '#666' }}>
          No count items available
        </div>
      </div>
    )
  }

  return (
    <>
      <div className="rm-padding table-wrap">
        <List className="core-list content-wrap full" disablePadding>
          {listItem.map((el, index) => {
            const assetQty = Number(el.asset_qty) || 0
            const countedQty = Number(el.counted_qty) || 0
            const variance = countedQty - assetQty
            const hasDiscrepancy = variance !== 0

            return (
              <ListItem
                className="table-listItem"
                key={el.asset_count_detail_id || index}
                divider
                style={{
                  backgroundColor: hasDiscrepancy ? '#fff3e0' : 'white',
                  paddingTop: '12px',
                  paddingBottom: '12px',
                }}
              >
                <ListItemText
                  primary={
                    <Grid
                      container
                      justifyContent="flex-start"
                      spacing={0}
                      alignItems="center"
                    >
                      <Grid
                        item
                        xs={8}
                        style={{
                          placeSelf: 'start',
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        <div
                          className="xsTitle"
                          style={{ lineBreak: 'anywhere' }}
                        >
                          {index + 1}. {el.Asset?.name || 'Unknown Asset'}
                        </div>
                        {hasDiscrepancy ? (
                          <WarningIcon
                            style={{
                              marginLeft: '8px',
                              color: 'orange',
                              fontSize: '18px',
                            }}
                          />
                        ) : (
                          <CheckCircleIcon
                            style={{
                              marginLeft: '8px',
                              color: 'green',
                              fontSize: '18px',
                            }}
                          />
                        )}
                      </Grid>
                      <Grid item xs={4} style={{ textAlign: 'right' }}>
                        <span className="desc" style={{ color: '#666' }}>
                          {el.Asset?.asset_card_no || el.Asset?.DocNo || 'N/A'}
                        </span>
                      </Grid>
                    </Grid>
                  }
                  secondary={
                    <>
                      <Grid container alignItems="center" spacing={1}>
                        <Grid item xs={6}>
                          <span style={{ fontSize: '12px' }}>
                            {el.CostCentre?.Name || 'N/A'}
                          </span>
                        </Grid>
                        <Grid
                          item
                          xs={6}
                          style={{
                            textAlign: 'right',
                            display: 'flex',
                            justifyContent: 'flex-end',
                            alignItems: 'center',
                          }}
                        >
                          <span
                            style={{ fontSize: '12px', marginRight: '4px' }}
                          >
                            Counted: {countedQty} /
                          </span>
                          <span
                            style={{
                              fontSize: '12px',
                              marginRight: '4px',
                              color: '#F39C12',
                            }}
                          >
                            Expected: {assetQty}
                          </span>
                        </Grid>
                      </Grid>
                      <Grid container alignItems="center" spacing={1}>
                        <Grid
                          item
                          xs={6}
                          style={{ display: 'flex', alignItems: 'center' }}
                        >
                          <LocationOnIcon
                            style={{
                              fontSize: 16,
                              marginRight: 4,
                              color: '#F39C12',
                            }}
                          />
                          <span style={{ fontSize: '12px' }}>
                            {el.Location?.name || 'N/A'}
                          </span>
                        </Grid>
                        <Grid item xs={6} style={{ textAlign: 'right' }}>
                          {hasDiscrepancy && (
                            <span
                              style={{
                                fontSize: '12px',
                                color: variance > 0 ? 'green' : 'red',
                                fontWeight: 'bold',
                              }}
                            >
                              Variance: {variance > 0 ? '+' : ''}
                              {variance}
                            </span>
                          )}
                        </Grid>
                      </Grid>
                      {el.count_note && (
                        <Grid
                          container
                          alignItems="center"
                          spacing={1}
                          style={{ marginTop: '4px' }}
                        >
                          <Grid item xs={12}>
                            <span
                              style={{
                                fontSize: '11px',
                                color: '#666',
                                fontStyle: 'italic',
                              }}
                            >
                              Note: {el.count_note}
                            </span>
                          </Grid>
                        </Grid>
                      )}
                    </>
                  }
                />
              </ListItem>
            )
          })}
        </List>
      </div>
      <div
        className="footer-label"
        style={{
          background: '#bfd3ff',
        }}
      ></div>
    </>
  )
}
